/**
 * Created by uri.khaimov on 23/11/2017.
 */
import PropTypes from 'prop-types';

import React from 'react';
import Style from './columnsContainer.scss';
import Cx from 'classnames';

const ColumnsContainer = function ({listColumnsData, isPendingActionItem}) {
    let columnClassName = '';
    let columnsContainer =  listColumnsData.slice(0, 2).map((column, index)=> {
        isPendingActionItem ?  columnClassName =`workFlowColumn${index+1}` : columnClassName =`column${index+1}`;
        if(column) {
            return (
                <div key={column.key}
                     className={Cx(Style.requestListItemMoreDetails, 'requestListItemMoreDetails', columnClassName)}>
                    <strong>{column.keyCaption }</strong>
                    <div className={Style.columnDefault}>
                        <div className={Style.textBlockEllipsis} title= {column.valueCaption}> {column.valueCaption}</div>
                    </div>
                </div>
            )
        }
    });

    return (
        <div className={Style.moreDetailsWrapper}>
            {columnsContainer}
        </div>

    );

};

ColumnsContainer.propTypes = {
    listColumnsData: PropTypes.array.isRequired,
    isPendingActionItem:PropTypes.bool.isRequired
};

export default ColumnsContainer;



// WEBPACK FOOTER //
// ./components/Scoreboard/columnsContainer.js